<template>
  <f7-page>
    <div class="bg-theme-color text-align-center text-color-white" style="height:160px;">
      <div style="padding:10px 0 15px 0;">
        <f7-icon f7="person" size="100px" color="white"></f7-icon>
      </div>
      <f7-block class="no-margin text-color-white" style="font-size:1.2em;">
        {{ this.$root.$data.login_name }}
      </f7-block>
    </div>
    <f7-list class="no-margin">
      <f7-list-item link="/" title="홈" view="#main-view" panel-close><img src="../assets/img_home.png" slot="media" style="width:24px;"></f7-list-item>
      <f7-list-item link="/sales/" title="판매관리" view="#main-view" panel-close><img src="../assets/img_sales.png" slot="media" style="width:24px;"></f7-list-item>
      <f7-list-item link="/payment-list/" title="결제내역조회" view="#main-view" panel-close><img src="../assets/img_payment_list.png" slot="media" style="width:24px;"></f7-list-item>
      <f7-list-item link="/settings/" title="환경설정" view="#main-view" panel-close><img src="../assets/img_settings.png" slot="media" style="width:24px;"></f7-list-item>
      <f7-list-item @click="logout" title="로그아웃" panel-close><img src="../assets/img_exit.png" slot="media" style="width:24px;"></f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
export default {
  methods: {
    // 로그아웃
    logout() {
      // 좌측메뉴 닫기
      this.$f7.panel.close();

      // 로그인정보 삭제
      localStorage.removeItem('admin_id');
      localStorage.removeItem('login_id');
      localStorage.removeItem('login_name');
      localStorage.removeItem('group_code');
      localStorage.removeItem('tourist_id');
      localStorage.removeItem('admin_tourist_name');
      localStorage.removeItem('eating_house_yn');
      localStorage.removeItem('goods_store_yn');
      localStorage.removeItem('use_barcode_limit_yn');

      // 로그인 화면 표시
      this.$f7.loginScreen.open('.login-screen');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/side-menu.vue